import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"},
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(6.10352 0 0 6.10352 -2443.69 -508.27)" }, [
      _createElementVNode("path", { d: "M462.317 85.217h-40c-10.999 0-20 9.001-20 20v40.002c0 10.996 9.001 20 20 20h40c10.999 0 20-9.004 20-20v-40.002c0-10.999-9.001-20-20-20m13.333 60.002c0 7.35-5.979 13.333-13.333 13.333h-40c-7.351 0-13.333-5.983-13.333-13.333v-40.002c0-7.352 5.982-13.333 13.333-13.333h40c7.354 0 13.333 5.981 13.333 13.333z" }),
      _createElementVNode("circle", {
        cx: "463.984",
        cy: "103.55",
        r: "5"
      }),
      _createElementVNode("path", { d: "M442.317 105.217c-11.048 0-20 8.953-20 20 0 11.043 8.952 20.002 20 20.002 11.045 0 20-8.959 20-20.002 0-11.047-8.955-20-20-20m0 33.335c-7.363 0-13.333-5.97-13.333-13.335s5.97-13.333 13.333-13.333 13.333 5.968 13.333 13.333-5.97 13.335-13.333 13.335" })
    ], -1)
  ])))
}
export default { render: render }